__turbopack_context__.v({
  "formModal": "ModalMenu-module-scss-module__oYn77G__formModal",
  "formModalBack": "ModalMenu-module-scss-module__oYn77G__formModalBack",
  "formModalBtnClose": "ModalMenu-module-scss-module__oYn77G__formModalBtnClose",
  "formModalContainer": "ModalMenu-module-scss-module__oYn77G__formModalContainer",
  "formModalTitle": "ModalMenu-module-scss-module__oYn77G__formModalTitle",
  "formModal__box": "ModalMenu-module-scss-module__oYn77G__formModal__box",
  "formModal__link": "ModalMenu-module-scss-module__oYn77G__formModal__link",
  "formModal__links": "ModalMenu-module-scss-module__oYn77G__formModal__links",
  "formModal__route__btn": "ModalMenu-module-scss-module__oYn77G__formModal__route__btn",
  "formModal__routes__btn": "ModalMenu-module-scss-module__oYn77G__formModal__routes__btn",
  "formModal__svgClass": "ModalMenu-module-scss-module__oYn77G__formModal__svgClass",
  "formModal__top": "ModalMenu-module-scss-module__oYn77G__formModal__top",
  "gradient": "ModalMenu-module-scss-module__oYn77G__gradient",
  "scrollableContent": "ModalMenu-module-scss-module__oYn77G__scrollableContent",
});
